import React from "react";
import { useHistory, Link, NavLink } from "react-router-dom";
import { useLoginState, useUserPremiumState } from "lib/hooks/userHooks";
import AdBoxWrapper from "components/Ads/AdBoxWrapper";
import AdComponent from "components/Ads/AdComponent";
import SearchBar from "components/SearchBar";
import NewRegionSelector from "components/Masthead/NewRegionSelector";
import { getAppDownloadUrl } from "lib/general-helper";
import { ReactComponent as WindowsIcon } from "svg/windows.svg";
import { ReactComponent as LolLogo } from "svg/League_GameSwitcher_Icon.svg";
import { ReactComponent as WowLogo } from "svg/WoW-SelectorLogo.svg";
import { ReactComponent as ValorantLogo } from "svg/valorant-logo.svg";
import GameButton from "./components/GameButton";

const DesktopAppLandingPage = () => {
  const history = useHistory();
  const isLoggedIn = useLoginState();
  const isPremium = useUserPremiumState();
  const games = [
    {
      logo: <LolLogo />,
      link: "/",
    },
    {
      logo: <ValorantLogo />,
      showNew: true,
      link: "/val",
      id: "val",
    },
    {
      logo: <WowLogo />,
      link: "/wow/",
      showNew: true,
      id: "wow",
    },
  ];

  return (
    <div className="desktop-app-landing-page">
      <div className="landing-background">
        <div className="overlay" />
        <video autoPlay loop muted>
          <source type="video/webm" src="https://static.bigbrain.gg/assets/ugg/pages/desktop-app/ugg-app-landing.webm" />
        </video>
      </div>
      <div className="desktop-app-landing-page_header">
        <img src="https://static.bigbrain.gg/assets/lol/performance_analysis/images/UGG_Logo_Blue_3.svg" alt="U.GG Logo" />
        <div>
          <h1>THE APP IS HERE.</h1>
          <Link className="btn-blue btn-blue_hover download-btn" to={"/app?utm_source=ugghome"}>
            <WindowsIcon className="windows-icon" />
            <span>Download Now</span>
          </Link>
        </div>
      </div>
      <div className="large-search search-container">
        <SearchBar
          isLanding={true}
          searchDefault={""}
          placeholder={"Search Yourself or a Champion"}
          history={history}
          autoFocus={true}
          searchBarId="landing"
        />
      </div>
      <NewRegionSelector />
      <div className="game-switcher">
        {games.map((x, i) => (
          <GameButton key={i} {...x} />
        ))}
      </div>
      {(!isLoggedIn || !isPremium.isPremium) && (
        <AdBoxWrapper
          styles={{ marginTop: 65, marginBottom: 20, paddingLeft: 21, paddingRight: 21, display: "flex", height: "auto" }}
          minAdWidth={970}
          minAdHeight={90}
        >
          <AdComponent slotId="div-gpt-ad-ugg-8" />
        </AdBoxWrapper>
      )}
    </div>
  );
};

export default DesktopAppLandingPage;
